import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {usePresupuesto} from "../../../../Profile.jsx";
import {useEditor} from "../../../../../../App.jsx";
import {IconEdit, IconPlus, IconUser} from "../../../../../Customiz3r/components/ToolSelectorTop/Icons.jsx";
import {EyeIcon} from "@heroicons/react/20/solid/index.js";

const ProyectoViewer = () => {
    const [proyecto, setProyecto] = useState(null);

    const {presupuesto, setPresupuesto} = usePresupuesto();
    const {stateEditor, setStateEditor} = useEditor();

    useEffect(() => {
        if (stateEditor?.editorID) {
            // Cargar los datos del proyecto
            axios.get(`/proyectos/${stateEditor?.editorID}/`)
                .then(response => {
                    setProyecto(response.data);
                })
                .catch(error => {
                    console.error('Error al cargar el proyecto:', error);
                });
        }
        console.log("ProyectoViewer", stateEditor?.editorID);
    }, [stateEditor?.editorID]);

    const handleEdit = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: stateEditor?.editorID,
            editorType: "proyecto_editor"
        })

    };

    const handleEditPresupuesto = (id) =>{
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: id,
            editorType: "presupuesto_editor"
        })
    }
    const handleVerPresupuesto = (id) =>{
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: id,
            editorType: "presupuesto_viewer"
        })
        setPresupuesto(proyecto.presupuestos.filter(presupuesto => presupuesto.id === id)[0]);
    }

    const addPresupuesto = () => {
        setStateEditor({
            ...stateEditor,
            editor: true,
            editorID: "add",
            editorType: "presupuesto_editor"
        });
    }
    return (
        <div className="h-full mx-auto p-6 pt-2 bg-white text-gray-800 dark:bg-gray-800 dark:text-white">
            <div className="absolute top-3 right-2 flex space-x-3">
                <button
                    className="bg-red-500 hover:bg-red-700 text-white font-bold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                    onClick={() => {
                        setStateEditor({
                            ...stateEditor,
                            editor: true,
                            editorID: proyecto.id,
                            editorType: "proyecto_editor"
                        });
                    }}
                    aria-label="Edit Proyecto"
                    type="button"
                >
                    <div className="flex items-center">
                        <IconEdit className="w-5 h-5"/>
                        <span className="ml-2">Editar Proyecto</span>
                    </div>

                </button>
                <button
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition duration-200 ease-in-out"
                    onClick={() => {
                        setStateEditor({
                            ...stateEditor,
                            editorType: "cliente_view",
                            editorID: proyecto.cliente,
                            editor: true
                        });
                    }}
                    aria-label="Go back"
                >
                    <div className="flex items-center">
                        <IconUser className="w-5 h-5"/>
                        <span className="ml-2">Cliente</span>
                    </div>

                </button>

            </div>

            {proyecto ? (
                <>
                    <h2 className='text-3xl mb-4'>{proyecto.nombre}</h2>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Detalles del Proyecto</h2>
                        <p><strong>Descripción:</strong> {proyecto.descripcion}</p>
                        <p><strong>Estado:</strong> {proyecto.estado}</p>
                        <p><strong>Fecha de Inicio:</strong> {proyecto.fecha_inicio}</p>
                        <p><strong>Fecha de Fin:</strong> {proyecto.fecha_fin || 'No especificada'}</p>
                    </div>
                    <div className="mb-4">
                        <div className="grid grid-cols-5 gap-4">
                            <div className="col-span-3">
                                <h2 className="text-lg font-bold mb-2 w-full">
                                    Lista de presupuestos
                                </h2>
                            </div>
                            <div className="col-start-4 col-span-2 grid">
                                <button
                                    className="flex items-center w-full bg-green-500 text-white py-1 px-3 ml-2 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 dark:bg-green-600 dark:hover:bg-green-700 transition duration-200 ease-in-out"
                                    onClick={() => addPresupuesto(proyecto.id)}
                                    aria-label="Añadir Presupuesto"
                                >
                                    <IconPlus className="w-4 h-4 inline-block" />
                                    <span className="ml-2">Añadir Presupuesto</span>
                                </button>
                            </div>
                        </div>



                    </div>
                    <div className="mb-4">
                        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
                            <thead>
                            <tr className="bg-gray-100 dark:bg-gray-700">
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">#</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Desc</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Fecha de Creación</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Aprobado</th>
                                <th className="py-3 px-4 border-b text-left dark:text-gray-300">Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {proyecto.presupuestos?.map((presupuesto, index) => (
                                <tr key={presupuesto.id} className="hover:bg-gray-50 dark:hover:bg-gray-600 transition duration-150 ease-in-out">
                                    <td className="py-2 px-4 border-b dark:border-gray-700">{presupuesto.id}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{presupuesto.descripcion}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">{presupuesto.fecha_creacion}</td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700 dark:text-gray-300">
                                        {presupuesto.aprobado ? 'Sí' : 'No'}
                                    </td>
                                    <td className="py-2 px-4 border-b dark:border-gray-700">

                                        <button
                                            className="bg-green-500 text-white py-1 px-3  rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 dark:bg-green-600 dark:hover:bg-green-700"
                                            onClick={() => handleVerPresupuesto(presupuesto.id)}
                                        >
                                            <EyeIcon className="w-5 h-5"/>

                                        </button>
                                        <button
                                            className="bg-blue-500 text-white py-1 px-3 ml-2 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700"
                                            onClick={() => handleEditPresupuesto(presupuesto.id)}
                                        >
                                            <IconEdit className="w-5 h-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                    </div>

{/*
                    <div className="flex items-center justify-between">
                        <button
                            onClick={handleEdit}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            type="button"
                        >
                            Editar Proyecto
                        </button>

                        <button
                            onClick={() => {
                                setStateEditor({
                                    ...stateEditor,
                                    editor: false,
                                    editorID: null,
                                    editorType: null
                                });
                            }} // Cierra el visualizador
                            className="bg-transparent hover:bg-gray-500 text-gray-700 dark:text-gray-300 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded"
                            type="button"
                        >
                            Cerrar
                        </button>
                    </div>
*/}
                </>
            ) : (
                <p>Cargando información del proyecto...</p>
            )}
        </div>
    );
};

export default ProyectoViewer;
